import styled from 'styled-components';

export const StyledMainLayoutContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    min-height: 100vh;

    ${theme.breakpoints.down('sm')}{
        background: transparent;
    }
    `}
`;

export const StyledBackground = styled.div`
    ${({ theme }) => `
    position: absolute;
    inset: 0;
    z-index: -1;

    background-image: ${theme.palette.common.primaryGradient};
    transform: matrix(-1, 0, 0, 1, 0, 0);

    `}
`;

export const StyledContentContainer = styled.div`
    ${({ theme, role }) => `
    flex-grow: 1;
    position: relative;

    ${theme.breakpoints.down('sm')}{
        border-radius: 0;
    }

    display: flex;
    flex-direction: column;
    align-items: center;

    border-radius: ${role === 'provider' ? 0 : '16px 0 0 16px'};

    `}
`;
